import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AppConstants } from '../app.constants';

@Injectable({
	providedIn: 'root'
})
export class NewsService {

	private newsUrlBaseUrl: string = AppConstants.newsUrl;

	constructor(private http: HttpClient) { }

	public async getLegalNews(): Promise<any> {
		const res = await firstValueFrom(this.http.get<any>(`${this.newsUrlBaseUrl}`));
		return res[1];
	}

}
